import apiClient from '@u/apiClient.js'

export default {
  fetchEnaosItemsConfig({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`item/${payload.item_id}/enaos/item-for-sales`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  fetchEnaosItemsOptionConfig({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .get(`item/${payload.item_id}/enaos/item-for-sales-option`)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createEnaosItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(`item/${payload.item_id}/enaos/item-for-sales`, payload.data)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  updateEnaosItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .put(
          `item/${payload.item_id}/enaos/${payload.enaos_item_id}/item-for-sales`,
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  createEnaosItemOption({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(
          `item/${payload.item_id}/enaos/item-for-sales-option`,
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  deleteEnaosItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .delete(
          `item/${payload.item_id}/enaos/item-for-sales/${payload.enaos_item_id}?enaos_id=${payload.data.enaos_id}`
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  deleteEnaosItemOption({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .delete(
          `item/${payload.item_id}/enaos/item-for-sales-option/${payload.enaos_item_id}/?enaos_id=${payload.data.enaos_id}`
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  hideEnaosItems({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(
          `item/${payload.item_id}/enaos/${payload.enaos_item_id}/hide`,
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  linkEnaosItemAndOption({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(
          `item/${payload.item_id}/enaos/${payload.enaos_item_id}/link`,
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  unlinkEnaosItemAndOption({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .post(
          `item/${payload.item_id}/enaos/${payload.enaos_item_id}/unlink`,
          payload.data
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
